<template>
    <el-dialog
        class="address-list"
        :visible.sync="listVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1100px"
        title="Address list"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-table
                ref="shippingTable"
                :data="tableData"
                :cell-style="cellStyle"
                style="width: 100%"
                header-cell-class-name="header-cell-class-name"
                cell-class-name="cell-class-name"
            >
                <el-table-column label="Name">
                    <template slot-scope="scope">
                        <div class="name">
                            <i
                                class="el-icon-circle-check"
                                v-if="scope.row.default"
                            ></i
                            >{{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Street Address"
                    width="150"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div class="ellipsis">
                            {{ scope.row.street1 + scope.row.street2 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="City" prop="city"></el-table-column>
                <el-table-column
                    label="Country"
                    prop="country_name"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="State" prop="state"></el-table-column>
                <el-table-column
                    label="Phone"
                    prop="phone"
                    width="150"
                ></el-table-column>
                <el-table-column
                    label="Postal Code"
                    prop="postal_code"
                    width="120"
                ></el-table-column>
                <el-table-column label="Operation">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="use(scope.row)"
                            v-if="isShowUse"
                            >Use</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            @click="edit(scope.row)"
                            >Edit</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="addAddress"
                >New Address</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            tableData: [],
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:listVisible", false);
        },
        async initialize() {
            this.userAddress();
        },
        userAddress() {
            cmofferApi.userAddress({}, "get").then((res) => {
                if (res) {
                    this.tableData = res.data;
                }
            });
        },
        use(row) {
            this.$emit("replaceAddress", row);
            this.closeDialog();
        },
        edit(row) {
            this.$emit("editAddress", row);
            this.closeDialog();
        },
        addAddress() {
            this.closeDialog();
            this.$parent.add();
        },
    },
    props: {
        listVisible: Boolean,
        isShowUse: Boolean,
    },
    watch: {
        listVisible() {
            if (this.listVisible) {
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.address-list {
    ::v-deep .container {
        padding: 20px;
        .name {
            position: relative;
            white-space: normal;
            i {
                color: $color-primary;
                font-size: 14px;
                position: absolute;
                left: -15px;
                top: 55%;
                transform: translateY(-50%);
            }
        }
        .header-cell-class-name {
            font-size: 13px;
            background-color: transparent;
            color: $color-333333 !important;
            text-align: center;
        }
        .cell-class-name {
            font-size: 13px;
            vertical-align: top;
            text-align: center;
            .el-button--mini {
                color: $color-primary-blue;
                &:active {
                    opacity: 0.6;
                }
            }
            &:nth-child(1) {
                .cell {
                    padding-left: 15px;
                }
            }
        }
    }
}
</style>
